import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import CustomForm from "../../../components/CustomForm/CustomForm";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../components/Loader/Loader";

const EditExamRelation = () => {
  const initialFormData = {
    subject: "",
    fullMark: "",
    passMark: "",
  };
  const navigate = useNavigate();
  const location = useLocation();
  const activeURL = location.pathname.split("/")[5];
  const [formData, setFormData] = useState(initialFormData);
  const [data, setData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await adminRequest.post(
          `${BASE_URL}/examSubject/relation/viewOne`,
          {
            uuid: `${activeURL}`,
          },
        );
        setData(response.data);
        setFormData({
          subject: response.data.data.subject,
          fullMark: response.data.data.fullMark,
          passMark: response.data.data.passMark,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [activeURL]);

  if (!data || !data.data) {
    return <Loader />;
  }
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/examSubject/relation/update`, {
          uuid: activeURL,
          subject: formData.subject,
          fullMark: formData.fullMark,
          passMark: formData.passMark,
        }),
        {
          pending: "Updating....",
        },
      );

      toast.success(response.data.message, {
        autoClose: 500,
        onClose: () => navigate(-1),
      });

      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fields = [
    {
      name: "subject",
      label: "Subject",
      type: "text",
      value: formData.subject,
      onChange: handleChange,
    },

    {
      name: "fullMark",
      label: "Full Mark",
      type: "number",
      value: formData.fullMark,
      onChange: handleChange,
    },
    {
      name: "passMark",
      label: "Pass Mark",
      type: "number",
      value: formData.passMark,
      onChange: handleChange,
    },
  ];

  return (
    <div className="editExamSubRelContainer">
      <CustomForm
        header="Edit Subject"
        fields={fields}
        flexDirection="row"
        createButtonLabel="Update"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default EditExamRelation;
